// Adds +params+ to +url+ without dropping the query the URL already carries. The capacity board's
// endpoint URLs name the planning version on screen (`?scenario_id=…`, see
// Planning::BaseController#default_url_options); gluing `?${query}` onto them would lose it, and
// the request would land in the primary plan. A relative URL stays relative.
// A key in +params+ replaces the URL's values for it; repeated keys (`ids[]=1&ids[]=2`) all stay.
export function urlWithQuery(url, params) {
  const [path, existing] = url.split("?")
  const query = new URLSearchParams(existing)
  const added = new URLSearchParams(params)
  for (const key of new Set(added.keys())) query.delete(key)
  for (const [key, value] of added) query.append(key, value)
  const queryString = query.toString()
  return queryString ? `${path}?${queryString}` : path
}
